const lt = {
  // App
  app: {
    name: 'A5Suite',
    loading: 'Kraunama...',
  },

  // Auth
  auth: {
    username: 'Naudotojo vardas',
    password: 'Slaptažodis',
    signIn: 'Prisijungti',
    signingIn: 'Prisijungiama...',
    loginFailed: 'Prisijungimas nepavyko',
    signOut: 'Atsijungti',
  },

  // Navigation
  nav: {
    dashboard: 'Prietaisų skydelis',
    sales: 'Pardavimai',
    purchases: 'Pirkimai',
    bankingCash: 'Bankas ir kasa',
    journal: 'Žurnalas',
    assets: 'Ilgalaikis turtas',
    reports: 'Ataskaitos',
    taxCompliance: 'Mokesčiai ir atitiktis',
    close: 'Uždaryti',
    setup: 'Nuostatos',
    accounts: 'Sąskaitų planas',
    contacts: 'Kontaktai',
    catalog: 'Katalogas',
    aiAudit: 'AI ir auditas',
    arena: 'Agentų arena',
    settings: 'Nustatymai',
    inventory: 'Atsargos',
    payroll: 'Darbo užmokestis',
    advanceReports: 'Avansinės ataskaitos',
    adminOnly: 'Tik administratoriui',
  },

  // Common
  common: {
    save: 'Išsaugoti',
    saving: 'Saugoma...',
    create: 'Sukurti',
    cancel: 'Atšaukti',
    edit: 'Redaguoti',
    delete: 'Ištrinti',
    close: 'Uždaryti',
    back: 'Atgal',
    search: 'Paieška',
    searchPlaceholder: 'Ieškoti pagal turinį, dokumento nr...',
    from: 'Nuo',
    to: 'Iki',
    date: 'Data',
    name: 'Pavadinimas',
    code: 'Kodas',
    type: 'Tipas',
    status: 'Būsena',
    actions: 'Veiksmai',
    loading: 'Kraunama...',
    noData: 'Nėra duomenų',
    confirm: 'Patvirtinti',
    yes: 'Taip',
    no: 'Ne',
    active: 'Aktyvus',
    obsolete: 'Nenaudojamas',
    manage: 'Valdyti',
    viewAll: 'Žiūrėti visus',
    details: 'Išsamiau',
    dateFrom: 'Galioja nuo',
    dateTo: 'Galioja iki',
    person: 'Asmuo',
    content: 'Turinys',
    amount: 'Suma',
    currency: 'Valiuta',
    total: 'Viso',
    description: 'Aprašymas',
    none: '-- Nėra --',
    noPerson: 'Be asmens',
    account: 'Sąskaita',
    accountName: 'Sąskaitos pavadinimas',
    docNumber: 'Dokumento nr.',
    docType: 'Dokumento tipas',
    tryAgain: 'Bandyti dar kartą',
    done: 'Atlikta',
    preview: 'Peržiūra',
    required: '* Būtinas',
    language: 'Kalba',
  },

  // Layout
  layout: {
    noWorkspace: 'Nėra aktyvios darbo srities',
    createOrImport: 'Sukurkite arba importuokite darbo sritį, kad pradėtumėte dirbti su apskaitos duomenimis.',
    manageWorkspaces: 'Valdyti darbo sritis',
    workspaces: 'Darbo sritys',
    company: 'Įmonė',
    area: 'Sritis',
    aiAssistant: 'AI Asistentas',
    searchCtrlK: 'Paieška (Ctrl+K)',
    moduleLoading: 'Kraunamas modulis...',
  },

  // Workspace
  workspace: {
    title: 'Darbo sritys',
    createNew: 'Sukurti naują',
    importLegacy: 'Importuoti seną duomenų bazę',
    noWorkspaces: 'Nėra darbo sričių',
  },

  // Dashboard
  dashboard: {
    code: 'Kodas',
    vat: 'PVM',
    invoice: '+ Sąskaita faktūra',
    journalBtn: 'Žurnalas',
    closeReadiness: 'Uždarymo pasirengimas',
    cashPosition: 'Pinigų padėtis',
    anomaliesRisk: 'Anomalijos ir rizika',
    aiActivity: 'AI veikla',
    banking: 'Bankas',
    critical: 'kritinių',
    warnings: 'įspėjimų',
    info: 'informacinių',
    allClear: 'Viskas tvarkoje',
    noAnomalies: 'Anomalijų nerasta',
    totalDecisions: 'iš viso sprendimų',
    recentJournal: 'Paskiausi žurnalo įrašai',
    recentInvoices: 'Paskiausios sąskaitos faktūros',
    trialBalance: 'Bandomasis balansas',
    asOfToday: 'Šiandienos',
    vatSummary: 'PVM suvestinė',
    taxReports: 'Mokesčių ataskaitos',
    saftExport: 'SAFT eksportas',
    xmlForVmi: 'XML VMI',
    settingsBtn: 'Nustatymai',
    companyAndAccounts: 'Įmonė ir sąskaitos',
    accounts: 'Sąskaitos',
    trialBalanceItems: 'Bandomojo balanso įrašai',
    invoicesMade: 'Sąskaitos faktūros (Išrašytos)',
    debit: 'Debetas',
    credit: 'Kreditas',
    class: 'Klasė',
    longTermAssets: 'Ilgalaikis turtas',
    shortTermAssets: 'Trumpalaikis turtas',
    equity: 'Nuosavas kapitalas',
    liabilities: 'Įsipareigojimai',
    sales: 'Pardavimai',
    costs: 'Sąnaudos',
    noEntries: 'Nėra įrašų',
    noInvoices: 'Nėra sąskaitų faktūrų',
    ar: 'Gautinos sumos',
    ap: 'Mokėtinos sumos',
    out: 'IŠ',
    in: 'Į',
    decisionLog: 'Sprendimų žurnalas',
  },

  // Invoices
  invoices: {
    salesTitle: 'Pardavimo sąskaitos faktūros (Išrašytos)',
    purchaseTitle: 'Pirkimo sąskaitos faktūros (Gautos)',
    newInvoice: '+ Nauja sąskaita faktūra',
    salesTab: 'Pardavimai (Išrašytos)',
    purchasesTab: 'Pirkimai (Gautos)',
    draft: 'Juodraštis',
    post: 'Registruoti',
    client: 'Klientas',
    supplier: 'Tiekėjas',
    sum: 'Suma',
    vat: 'PVM',
    deleteTitle: 'Ištrinti sąskaitą faktūrą',
    deleteMessage: 'Ar tikrai norite ištrinti sąskaitą faktūrą #{{id}}? Šio veiksmo negalima atšaukti.',
    postTitle: 'Registruoti sąskaitą faktūrą',
    postMessage: 'Registruoti sąskaitą faktūrą #{{id}} į didžiąją knygą? Bus sukurtas žurnalo įrašas.',
    noInvoicesFound: 'Sąskaitų faktūrų nerasta',
    // Credit Note
    creditNoteTitle: 'Nauja kreditinė sąskaita faktūra',
    createCreditNote: 'Kreditinė SF',
    creatingCreditNote: 'Kuriamas kreditinis dokumentas...',
    linkedInvoice: 'Susijusi sąskaita faktūra',
    unlinkInvoice: 'Atjungti',
    searchInvoicePlaceholder: 'Ieškoti sąskaitos pagal numerį, asmenį...',
    creditNoteFor: 'Kreditinė sąskaita už',
    selectPerson: '-- Pasirinkti --',
    creditNoteContentPlaceholder: 'Kreditinės sąskaitos aprašymas...',
    invoiceDate: 'Sąskaitos data',
    documentNumber: 'Dokumento nr.',
    currencyRate: 'Valiutos kursas',
    unit: 'Vnt.',
    price: 'Kaina',
    qty: 'Kiekis',
    vatRate: 'PVM tarifas',
    lineItems: 'Eilutės',
    addLine: 'Pridėti eilutę',
    none: 'Be PVM',
    totalWithVat: 'Viso su PVM',
  },

  // Journal
  journal: {
    title: 'Žurnalas',
    newEntry: '+ Naujas įrašas',
    allEntries: 'Visi įrašai',
    postingLog: 'Registravimo žurnalas',
    templates: 'Šablonai',
    source: 'Šaltinis',
    allSources: 'Visi šaltiniai',
    manualEntry: 'Rankinis įrašas',
    invoicePosting: 'Sąskaitos faktūros registras',
    bankOperation: 'Banko operacija',
    periodClosing: 'Periodo uždarymas',
    aiGenerated: 'AI sugeneruotas',
    adjustment: 'Koregavimas',
    debit: 'Debetas',
    credit: 'Kreditas',
    balanced: 'Subalansuota',
    notBalanced: 'Nesubalansuota',
    unbalanced: 'NESUBALANCUOTA',
    totalDebit: 'Viso debetas',
    totalCredit: 'Viso kreditas',
    difference: 'Skirtumas',
    noJournalEntriesFound: 'Žurnalo įrašų nerasta',
    noPostingLogEntries: 'Registravimo žurnalo įrašų nėra',
    posted: 'Užregistruota',
    postedDate: 'Užregistruota data',
    auditTrailDescription: 'Visų žurnalo registravimų audito pėdsakas, rodantis kas, ką, kada ir iš kurio šaltinio. Kiekvienas finansinis registravimas yra nekintamas sukūrus.',
    createTemplate: '+ Sukurti šabloną',
    useTemplate: 'Naudoti šabloną',
    // Journal Edit
    editEntry: 'Redaguoti žurnalo įrašą #{{id}}',
    newJournalEntry: 'Naujas žurnalo įrašas',
    documentNumber: 'Dokumento nr.',
    documentType: 'Dokumento tipas',
    content: 'Turinys',
    person: 'Asmuo',
    contentPlaceholder: 'Žurnalo įrašo aprašymas...',
    docRequired: 'Dokumento numeris yra būtinas',
    contentRequired: 'Turinys yra būtinas',
    lineWithAccountRequired: 'Būtina bent viena eilutė su sąskaita ir teigiama suma',
    everyLineMustHaveAccount: 'Kiekvienoje eilutėje su suma turi būti pasirinkta sąskaita',
    entryNotBalanced: 'Įrašas nesubalansuotas. Debetas: {{debit}}, Kreditas: {{credit}}, Skirtumas: {{difference}}',
    futureDateWarning: 'Įspėjimas: data yra ateityje.',
    noDebitLines: 'Nėra debeto eilučių',
    noCreditLines: 'Nėra kredito eilučių',
    debitTotal: 'Debetas (Debetas)',
    creditTotal: 'Kreditas (Kreditas)',
    addDebit: '+ Debetas',
    addCredit: '+ Kreditas',
    saveChanges: 'Išsaugoti pakeitimus',
    createEntry: 'Sukurti įrašą',
    // Journal Detail
    entryNotFound: 'Įrašas nerastas',
    entryDeleted: 'Žurnalo įrašas #{{id}} ištrintas',
    deleteTitle: 'Ištrinti žurnalo įrašą',
    deleteMessage: 'Visam laikui ištrinti žurnalo įrašą #{{id}}? Šio veiksmo negalima atšaukti.',
    cloneTitle: 'Duplikuoti žurnalo įrašą',
    cloneMessage: 'Sukurti žurnalo įrašo #{{id}} kopiją su šiandienos data?',
    clone: 'Duplikuoti',
    lines: 'Eilutės',
    // Document types
    docTypeGeneric: 'Bendras',
    docTypeSalesInvoice: 'Pardavimo sąskaita faktūra',
    docTypePurchaseInvoice: 'Pirkimo sąskaita faktūra',
    docTypeBankOp: 'Banko operacija',
    docTypeCashIncome: 'Kasos pajamos',
    docTypeCashSpending: 'Kasos išlaidos',
    docTypeOffset: 'Užskaita',
    docTypeWageSheet: 'Algalapis',
  },

  // Settings
  settings: {
    title: 'Nustatymai',
    // Company
    companyInfo: 'Įmonės informacija',
    companyName: 'Pavadinimas',
    companyCode: 'Įmonės kodas',
    vatCode: 'PVM kodas',
    address: 'Adresas',
    headPerson: 'Vadovas',
    createCompany: 'Sukurti įmonę',
    createCompanyDescription: 'Įmonė dar nenustatyta. Užpildykite žemiau esančią formą, kad pradėtumėte.',
    // Tax rates
    taxRates: 'Mokesčių tarifai',
    addTaxRate: '+ Pridėti mokesčiio tarifą',
    rate: 'Tarifas (%)',
    vatDebitAccount: 'PVM debeto sąskaita',
    vatCreditAccount: 'PVM kredito sąskaita',
    vatPurchaseAccount: 'PVM pirkimo sąskaita',
    validFrom: 'Galioja nuo',
    noTaxRates: 'Nėra mokesčių tarifų',
    failedToCreateTaxRate: 'Nepavyko sukurti mokesčio tarifo',
    // Document serials
    documentSerials: 'Dokumentų serijos',
    manageSerials: 'Valdyti serijas',
    lastNumber: 'Paskutinis nr.',
    pattern: 'Šablonas',
    reset: 'Atstatyti',
    noDocumentSerials: 'Dokumentų serijos nesukonfigūruotos',
    // Import
    importLegacyDb: 'Importuoti seną duomenų bazę',
    importDescription: 'Įkelkite Apskaita5 .db failą, kad sukurtumėte naują darbo sritį ir importuotumėte duomenis.',
    previewImport: 'Peržiūrėti importą',
    alreadyImported: 'Ši duomenų bazė jau importuota kaip darbo sritis „{{name}}". Pakartotinas importavimas sukurs atskirą darbo sritį su tais pačiais duomenimis.',
    entity: 'Objektas',
    records: 'Įrašai',
    importIntoNewWorkspace: 'Importuoti į naują darbo sritį',
    importSuccessful: 'Importavimas sėkmingas! {{count}} įrašai importuoti į darbo sritį „{{name}}".',
    table: 'Lentelė',
    // AI Agent
    aiAgentSettings: 'AI agento nustatymai',
    aiAgentDescription: 'Konfigūruoti įgaliojimų lygius kiekvienam AI darbo eigui',
    workflow: 'Darbo eiga',
    authorityLevel: 'Įgaliojimų lygis',
    aiDescription: 'Aprašymas',
    noAiWorkflows: 'AI darbo eigos nesukonfigūruotos',
    authorityAuditNote: 'Įgaliojimų pakeitimai registruojami audito žurnale. Numatytasis lygis yra „Siūlyti“, kol nepakeičiamas.',
    saveChanges: 'Išsaugoti pakeitimus ({{count}})',
    // Administration
    administration: 'Administravimas',
    docSerialsDescription: 'Valdyti dokumentų numeravimo šablonus, prievardžius ir sekas',
    userRolesPermissions: 'Vartotojų vaidmenys ir teisės',
    rolesDescription: 'Valdyti vaidmenis ir modulio lygio prieigos kontrolę',
    dataBackup: 'Atsarginė kopija',
    backupDescription: 'Eksportuoti įmonės duomenis kaip JSON atsarginės kopijos failą',
    emailConfiguration: 'El. pašto konfigūracija',
    emailDescription: 'SMTP nustatymai sąskaitų faktūrų siuntimui el. paštu',
  },

  // Accounts
  accounts: {
    title: 'Sąskaitų planas',
    trialBalance: 'Bandomasis balansas',
    newAccount: '+ Nauja sąskaita',
    accountNumber: 'Sąskaitos numeris',
    saftCode: 'SAFT kodas',
    number: 'Numeris',
    noAccounts: 'Sąskaitų nerasta',
    deleteConfirm: 'Ištrinti sąskaitą {{number}}?',
    classLabel: 'Klasė',
  },

  // Persons
  persons: {
    title: 'Kontaktai',
    subtitle: 'Bendras klientų, tiekėjų ir darbuotojų sąrašas',
    addContact: 'Pridėti kontaktą',
    total: 'Iš viso',
    customers: 'Klientai',
    vendors: 'Tiekėjai',
    employees: 'Darbuotojai',
    custVend: 'Klient+Tiek.',
    searchPlaceholder: 'Ieškoti pagal pavadinimą, kodą ar PVM kodą...',
    allContacts: 'Visi kontaktai',
    customerOnly: 'Tik klientai',
    vendorOnly: 'Tik tiekėjai',
    employeeOnly: 'Tik darbuotojai',
    custPlusVend: 'Klientas + Tiekėjas',
    hasAnyRole: 'Bet koks vaidmuo',
    receivables: 'Gautinos',
    payables: 'Mokėtinos',
    roles: 'Vaidmenys',
    noRole: 'Be vaidmens',
    both: 'Abu',
    noContacts: 'Kontaktų nerasta',
    editContact: 'Redaguoti kontaktą',
    newContact: 'Naujas kontaktas',
    receivablesAccount: 'Gautinų sąskaita',
    payablesAccount: 'Mokėtinų sąskaita',
    customer: 'Klientas',
    vendor: 'Tiekėjas',
    employee: 'Darbuotojas',
    naturalPerson: 'Fizinis asmuo',
    update: 'Atnaujinti',
    personDeleted: 'Asmuo #{{id}} ištrintas',
    deleteConfirm: 'Ištrinti {{name}}?',
    inactive: 'Neaktyvus',
    // Address fields
    street: 'Gatvė',
    city: 'Miestas',
    postalCode: 'Pašto kodas',
    country: 'Šalis',
    // Contact fields
    contactName: 'Kontaktinis asmuo',
    contactPhone: 'Telefonas',
    contactEmail: 'El. paštas',
    // Business terms
    paymentTermsDays: 'Mokėjimo terminas (dienos)',
    discountPercent: 'Nuolaida (%)',
    creditLimit: 'Kreditinis limitas',
    sector: 'Veiklos sektorius',
    notes: 'Pastabos',
  },

  // Periods
  periods: {
    closeTitle: 'Periodo uždarymas',
  },

  // Reports
  reports: {
    vatSummary: 'PVM suvestinė',
    vatDeclaration: 'PVM deklaracija',
    financialStatements: 'Finansinės ataskaitos',
    debtAging: 'Skolų senumo ataskaita',
    exportSaft: 'SAFT eksportas',
  },

  // Banking
  banking: {
    title: 'Banko operacijos',
    import: 'Banko išklotinės importas',
    importStatement: 'Importuoti išklotinę',
    newOperation: '+ Nauja operacija',
    cashOperations: 'Kasos operacijos',
    offsets: 'Užskaitos',
    inflowCredit: 'Pajamos (Kreditas)',
    outflowDebit: 'Išlaidos (Debetas)',
    netCashMovement: 'Grynasis pinigų judėjimas',
    debitAcct: 'Debeto sąsk.',
    creditAcct: 'Kredito sąsk.',
    noBankOperations: 'Šiuo laikotarpiu banko operacijų nerasta',
    editBankOperation: 'Redaguoti banko operaciją',
    newBankOperation: 'Nauja banko operacija',
    documentNumberLabel: 'Dokumento numeris *',
    amountLabel: 'Suma *',
    debitAccountLabel: 'Debeto sąskaita',
    creditAccountLabel: 'Kredito sąskaita',
    bankAccountCodeLabel: 'Banko sąskaitos kodas',
    personLabel: 'Asmuo',
    currencyLabel: 'Valiuta',
    currencyRateLabel: 'Valiutos kursas',
    updateOperation: 'Atnaujinti',
    createOperation: 'Sukurti',
    deleteOperation: 'Ištrinti operaciją',
    operationDeleted: 'Banko operacija #{{id}} ištrinta',
    reconciliationWorkspace: 'Suderinimo darbo sritis',
    reconciliationDescription: 'Banko suderinimas sugretins banko išrašo operacijas su vidiniais įrašais. Šiai funkcijai reikia sukonfigūruoti banko tiekėjo integraciją Nuostatose.',
    startReconciliation: 'Pradėti suderinimą (jau greitai)',
    selectAccount: '-- Pasirinkti --',
    selectPerson: '-- Nėra --',
    docNumberPlaceholder: 'pvz. BO-001',
    // Bank Import
    smartBankImport: 'Išmanus banko importas',
    backToBanking: 'Atgal į banką',
    total: 'Iš viso',
    highConfidence: 'Didelis pasitikėjimas',
    partialMatch: 'Dalinis atitikimas',
    noMatch: 'Atitikmens nėra',
    accepted: 'Priimta',
    totalInflow: 'Iš viso pajamos',
    totalOutflow: 'Iš viso išlaidos',
    detectedFormat: 'Aptiktas formatas',
    acceptAllGreen: 'Priimti visus žalius ({{count}})',
    acceptAll: 'Priimti visus',
    confirmOperations: 'Patvirtinti {{count}} operacijas',
    creating: 'Kuriama...',
    parseWarnings: 'Analizės įspėjimai',
    counterparty: 'Korespondentas',
    confidence: 'Pasitikėjimas',
    importComplete: 'Importas baigtas',
    created: 'Sukurta',
    skipped: 'Praleista',
    errors: 'Klaidos',
    importAnotherFile: 'Importuoti kitą failą',
    viewBankingOperations: 'Peržiūrėti banko operacijas',
    accountNumberHint: 'Jūsų banko sąskaitos numeris sąskaitų plane',
    dragAndDrop: 'Nuvilkite banko išklotinės failą čia',
    supportedFormats: 'Palaikomi formatai: CSV (SEB, Swedbank, Luminor), XML (Camt.053), MT940 (SWIFT)',
    browseFiles: 'Parinkti failą',
    pasteCsvText: 'Įklijuoti CSV tekstą',
    pasteBankStatement: 'Įklijuoti banko išklotinę',
    backToFileUpload: 'Atgal į failo įkėlimą',
    bankFormat: 'Banko formatas',
    autoDetect: 'Automatinis aptikimas',
    parseAndMatch: 'Analizuoti ir sugretinti',
    parsing: 'Analizuojama...',
    noOperations: 'Nėra operacijų',
    // Bank Accounts
    bankAccounts: 'Banko sąskaitos',
    manageAccounts: 'Valdyti sąskaitas',
    newAccount: '+ Nauja sąskaita',
    accountDeleted: 'Banko sąskaita ištrinta',
    accountUpdated: 'Banko sąskaita atnaujinta',
    accountCreated: 'Banko sąskaita sukurta',
    deleteAccountConfirm: 'Ištrinti šią banko sąskaitą?',
    accounts: 'Sąskaitos',
    balances: 'Balansai',
    statement: 'Išklotinė',
    accountName: 'Sąskaitos pavadinimas',
    bankNameCol: 'Bankas',
    glAccount: 'DK sąskaita',
    status: 'Būsena',
    active: 'Aktyvi',
    inactive: 'Neaktyvi',
    type: 'Tipas',
    noBankAccounts: 'Banko sąskaitos nesukonfigūruotos',
    totalNet: 'Grynasis balansas',
    debit: 'Debetas',
    credit: 'Kreditas',
    netBalance: 'Grynasis balansas',
    noBalances: 'Balansai neprieinami',
    openingBalance: 'Pradinis',
    periodDebit: 'Periodo debetas',
    periodCredit: 'Periodo kreditas',
    periodNet: 'Periodo skirtumas',
    closingBalance: 'Galutinis',
    noTransactions: 'Šiame periode operacijų nėra',
    selectAccountForStatement: 'Pasirinkite banko sąskaitą išklotinei peržiūrėti',
    chooseAccount: '-- Pasirinkite sąskaitą --',
    allTypes: 'Visos',
    typeBank: 'Banko sąskaita',
    typePseudo: 'Pseudo bankas',
    typeTill: 'Kasa',
    accountNameLabel: 'Sąskaitos pavadinimas',
    bankNameLabel: 'Banko pavadinimas',
    bankCodeLabel: 'Banko kodas',
    typeLabel: 'Sąskaitos tipas',
    glAccountLabel: 'DK sąskaitos numeris',
    editAccount: 'Redaguoti banko sąskaitą',
    // Reconciliation
    showUnreconciled: 'Rodyti nesugretintas',
    hideUnreconciled: 'Slėpti nesugretintas',
    unreconciledCount: 'nesugretintų operacijų (-os)',
    markReconciled: 'Pažymėti sugretintą',
    allReconciled: 'Visos operacijos sugretintos!',
    reconciliationUpdated: 'Sugretinimo būsena atnaujinta',
  },

  // AI Audit
  aiAudit: {
    title: 'AI ir auditas',
  },

  // Agent Arena
  arena: {
    title: 'Agentų arena',
    description: 'AI agentų testavimo ir varžybų aplinka.',
    comingSoon: 'Arena funkcija ruošiama. Laukite atnaujinimų.',
  },

  // Audit Trail
  audit: {
    title: 'Audito pėdsakas',
  },

  // Catalog
  catalog: {
    title: 'Prekių ir paslaugų katalogas',
  },

  // Error Boundary
  errorBoundary: {
    title: 'Kažkas nutiko',
    message: 'Programoje įvyko klaida. Bandykite perkrauti puslapį.',
    reload: 'Perkrauti',
  },

  // Confirm Dialog
  confirmDialog: {
    cancel: 'Atšaukti',
  },

  // Modules
  modules: {
    advanceReports: 'Avansinės ataskaitos',
    fixedAssets: 'Ilgalaikis turtas',
    inventory: 'Atsargos',
    payroll: 'Darbo užmokestis',
  },
};

export default lt;
export type TranslationKeys = typeof lt;
